<template>
      <!-- Controls -->
      <div class="row wrapper border-bottom white-bg page-heading py-1 mb-2">
        <div class="d-flex justify-content-end">
          <button @click="soagraph('soa')" class="btn-sm btn-outline-secondary ml-2 py-0 px-2">SoA</button>
          <!-- <button @click="visitSchedulegraph" class="btn-sm btn-outline-secondary ml-2 py-0 px-2">Visit Schedule</button> -->
          <button @click="siteentrollementfun" class="btn-sm btn-outline-secondary ml-2 py-0 px-2">Site Enrolment</button>
        <div class="mx-3 d-flex justify-content-end">
          <label class="mt-auto mb-auto mr-1">Select Site</label>
          <div class="mt-0">
          <select v-model="selectedsite" class="form-select py-1" @change="changesite()">
            <option
                v-for="sites in this.sites"
                :key="sites.siteID"
                :value="sites.siteID"
              >
                {{ sites.siteCode }}
              </option>
          </select>
        </div>
        </div>
        <div class="d-flex justify-content-end">
          <label class="mt-auto mb-auto mr-1">Select Subject</label>
          <div class="mt-0">
          <select v-model="selectedpatient" class="form-select py-1">
            <option
                v-for="patient in this.patients"
                :key="patient.patientId"
                :value="patient.patientId"
              >
                {{ patient.subjectId }}
              </option>
          </select>
        </div>
      </div>
        </div>
      </div>
      
   <div class="ibox-content pt-1"> 
    
    <div class="d-flex flex-wrap align-items-center">
       <div class="d-flex flex-wrap align-items-center col-md-7 px-0 soa-toolbar-controls">
       <!-- New Layout selection drop-down -->
       <div class="d-flex align-items-center mb-2">
         <label class="mt-auto mb-auto mr-1">Select Layout</label>
         <div class="mt-0">
           <select class="form-select py-1" v-model="selectedLayout">
             <option value="dagre">Dagre</option>
             <option value="breadthfirst">Breadthfirst</option>
             <option value="grid">Grid</option>
             <!-- <option value="circle">Circle</option>
             <option value="concentric">Concentric</option> -->
             <option value="cose">Cose</option>
             <!-- <option value="klay">Klay</option> -->
           </select>
         </div>
       </div>
       <template v-if="graphidentifier == 'soa'||graphidentifier == 'selectedpatient'">
       <div class="d-flex align-items-center mb-2">
         <label class="mt-auto mb-auto mr-1">Visit Label</label>
         <div class="mt-0">
           <select class="form-select py-1" v-model="customlabel[0].Custlabel">
             <option value="label">Visit Name</option>
             <option value="VisitNo">Visit No</option>
           </select>
         </div>
       </div>
      </template>
      <div class="d-flex align-items-center mb-2">
       <label class="mt-auto mb-auto mr-1">Select SoA</label>
       <div class="mt-0">
         <select class="form-select py-1 soa-select" v-model="SoA_selected" @change="loadGraph">
           <option value="">All SoA</option>
           <option
             v-for="soa in soalist"
             :key="soa.id || soa.soaId"
             :value="soa.soaId"
           >
             {{ soa.soaId }}
           </option>
         </select>
       </div>
      </div>
      <template v-if="graphidentifier == 'soa' && isArmSpecific == true" >
        <div class="d-flex align-items-center mb-2">
          <label class="mt-auto mb-auto mr-1">Study Arm</label>
          <div class="mt-0">
            <select class="form-select py-1" v-model="selectedArm"  @change="soagraph('armChange')">
              <option
                v-for="arm in armList"
                :key="arm.ArmCode"
                :value="arm.ArmCode"
              >
                {{ arm.ArmCode }}
              </option>
            </select>
          </div>
        </div>
      </template>
      </div>
      <div class="col-md-5 d-flex flex-wrap align-items-center justify-content-end pr-0">
       <!-- <button @click="resetgraph" class="btn-sm btn-outline-secondary ml-2 py-1 px-2 my-2 ">Reset Graph</button> -->
        <div v-if="graphidentifier == 'soa'" class="me-3">
        <label class="mb-0 me-2">{{ $t("navigations.versions") }}</label>
        <select
          class="form-select form-select-sm d-inline-block w-auto"
          v-model="selectedVersion"
          @change="loadGraph"
        >
          <option v-for="ver in versionList" :key="ver" :value="ver">
            {{ ver }}
          </option>
        </select>
      </div>
       <div class="m-2">
             <a @click="resetgraph()" class="close-link" title="Reset Graph">
              <img src="../../assets/images/reset_graph.svg" alt="Orientation" style="width: 26px; height: 26px"/>
             </a>
           </div>
       <div class="m-2">
             <a v-if="selectedorientation=='LR'" @click="selectedorientation = 'TB',layouconfigchange()" class="close-link" title="Horizontal Layout">
               <img src="../../assets/images/orientation_Horizontal.svg" alt="Orientation" style="width: 26px; height: 26px"/>
             </a>
             <a v-if="selectedorientation=='TB'" @click="selectedorientation = 'LR',layouconfigchange()" class="close-link" title="Vertical Layout">
               <img src="../../assets/images/orientation_Vertical.svg" alt="Orientation" style="width: 26px; height: 26px"/>
             </a>
       </div>
       <div class="m-2">
             <a @click="zoomout()" class="close-link" title="zoom out">
              <img src="../../assets/images/zoom_out_graph.svg" alt="Orientation" style="width: 26px; height: 26px"/>
             </a>
           </div>
           <div class="m-2">
             <a  @click="zoomin()" class="close-link" title="zoom in">
              <img src="../../assets/images/zoom_graph.svg" alt="Orientation" style="width: 26px; height: 26px"/>
             </a>
           </div>
      </div>
    </div>
    <div class="soa-graph-stage">
    <div class="d-flex totalborder" :class="{ 'graphs-loading': isGraphLoading }">
    <graph ref="childComp" class="col-md-10" :customlabels="customlabel" :key="menuitems" :selectedpatientid="selectedpatient" :stabilize-initial-render="true" @graph-ready="markGraphReady" @showsitegraph="showsitegraph" @showsubjectgraph="showsubjectgraph" @changevisitstatusmodel="changevisitstatusmodel" :collapsedtypes="collapsedtypes" :graphdata="graphdata" :selectedLayout="selectedLayout" :menuitems="menuitems" @showproperties="showproperties" @uncheduledvisit="openunscheduledvisitModal" @showformmodel="showformmodel" :donotcollapse="donotcollapse"/>

    <div v-if="Object.keys(graphdata).length != 0 && !isGraphLoading" class="col-md-2 p-4">
  <!-- Legend Items -->
  <div
  v-for="(item, key) in legendStatus"
  :key="key">
  <div
  v-if="typeArray.includes(key)"
  @mouseover="showPopup(key, $event)"
  @mouseleave="hidePopup"
  class="d-flex justify-content-between border-bottom mb-2 pb-1 legend-item"
>
  <span class="mr-2">{{ key }}:</span>
  <img
    :src="require(`@/assets/images/GraphShapes/${getIconName(key)}.svg`)"
    alt="Shape"
    class="legandicon"
  />
  </div>
</div>

  <!-- Popup Template -->
  <div v-if="popup.show" class="status-popup" :style="{ left: popup.x + 'px', top: popup.y + 'px' }">
    <div v-for="status in legendStatus[popup.type]" :key="status.label" class="status-item">
      <div class="color-circle" :style="{ backgroundColor: status.color }"></div>
      <span class="status-label">{{ status.label }}</span>
    </div>
  </div>
</div>

  </div>
  <div v-if="isGraphLoading" class="graph-loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
  </div>
 </div>
  <!-- Popup Details Modal -->
  <div v-if="detailspopup" class="modal-wrapper is-visible">
         <div class="modal-container">
          <div class="titleclass">
            <h4 class="px-3 mt-1">Details</h4>
            <div class="closebutton mt-1">
              <a style="color: white" class="close-link">
                <i class="fa fa-times" @click.prevent="closedetailsModal"></i>
              </a>
            </div>
          </div>
          <div class="modelbody p-0">
            <div class="mb-3 p-2">
              <div class="form-group">
                <div class="d-flex flex-column flex-lg-row">
                  <div class="col-lg-12 my-2">
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>Key</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, key) in nodeproperties" :key="key">
                          <td>{{ dictionaryfordetails[key]?dictionaryfordetails[key]:key }}</td>
                          <td>{{ value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="d-flex justify-content-center my-3">
                  <button class="save_btn py-1 px-4" @click="closedetailsModal">
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <!-- new visit create -->
      <manageVisitModal
        v-if="showSiteModal"
        :visitId="currentvisitid"
        @closeModal="closeModal()"
        @createVisit="loadGraph()"
      />
      <showformmodel
        v-if="setshowFormModal"
          :formid="currentform"
          :currentformstatus="currentformstatus"
          @closeformModal="closeformModal()"
      />
  <ChangeSchedulestatus 
      v-if="showChangeSchedule"
      :changeStatus="changeStatus"
      statusType="Visit"
      @closeModal="closeshowChangeSchedule()"
   />
  <UnscheduledVisitModal
    v-if="unscheduledvisitpopup"
    :patientId = selectedpatient
    :relatedId = popupdata.related
    @closeModal="closeunscheduledvisitModal()"
  />
  <!-- Popup unscheduled visit Modal -->
 
  </template>
  
  <script src="./soa.js">
  </script>
  
  <style scoped>
  @import "../../assets/css/style.css";
  
  #cy {
    width: 100%;
    height: 600px;
    border: 1px solid #ddd;
  }
  
  .popup-menu {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 5px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  .popup-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .popup-menu li {
    padding: 3px 8px;
    cursor: pointer;
  }
  
  .popup-menu li:hover {
    background: #f0f0f0;
  }
  
  .modal-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    pointer-events: auto;
    overflow: hidden;
    z-index: 9999;
  }
  
  .modal-container {
    background: #fff;
    width: 80%;
    max-width: 600px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .modal-containermaxwidth{
    background: #fff;
    width: 80%;
    max-width: 1000px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .is-visible {
    opacity: 1;
    pointer-events: auto;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .table th,
  .table td {
    padding: 8px;
    border: 1px solid #ddd;
  }
  
  .table th {
    background-color: #f4f4f9;
    font-weight: bold;
  }
  
  .table-striped tbody tr:nth-child(odd) {
    background-color: #f9f9f9;
  }
  .totalborder{
    border: 1px solid #ddd;
  }
  .spinnerborder{
    border: 1px solid #ddd;
    border-top: 0px;
  }
  .soa-graph-stage {
    position: relative;
  }
  .graphs-loading {
    visibility: hidden;
  }
  .graph-loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    z-index: 2;
  }
  .legandicon{
    width: 22px;
    height: 22px;
  }
  .soa-toolbar-controls {
    gap: 0.5rem 0.75rem;
  }
  .soa-select {
    min-width: 110px;
  }
.status-popup {
  position: fixed; /* Changed from absolute to fixed */
  background: white;
  border: 1px solid #ddd;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  width: 160px; /* Fixed width */
  left: 0; /* Will be overridden by inline style */
  top: 0; /* Will be overridden by inline style */
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
}

.color-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-label {
  font-size: 0.85rem;
  color: #333;
}
  </style>
  
